import { useState } from "react";
import Option from "../../../types/Option";
import { isEmpty } from "../../../utils/isEmpty";
import { Input } from "../../Input";
import { Dropdown } from "../../Dropdown";
import { Button } from "../../Button";

export const ModalUpdate = ({
  loading,
  item,
  onCancel,
  onConfirm,
  hojasOptions,
}: any) => {
  const [min_hojas, setSheetCountMin] = useState<number>(
    item.min_hojas
  );
  const [max_hojas, setSheetCountMax] = useState<number>(
    item.max_hojas
  );
  const [selectedSheet, setSelectedSheet] = useState<any>(
    item.sheet
      ? hojasOptions.filter((hoja: any) => hoja.value === item.sheet)[0]
      : hojasOptions[0]
  );
  const [precio, setPrice] = useState<number>(item.precio);

  const [errors, setErrors] = useState<any>({
    min_hojas: "",
    max_hojas: "",
    precio: "",
  });

  const onChangeSheetCountMin = (text: string) => {
    setSheetCountMin(Number(text));
  };

  const onChangeSheetCountMax = (text: string) => {
    setSheetCountMax(Number(text));
  };

  const onChangeSheet = (sheet: Option) => {
    setSelectedSheet(sheet);
  };

  const onChangePrice = (text: string) => {
    setPrice(Number(text));
  };

  const onClickConfirm = () => {
    if (isEmpty(min_hojas)) {
      setErrors({
        ...errors,
        min_hojas: "Requerido",
      });
    }

    if (isEmpty(min_hojas)) {
      setErrors({
        ...errors,
        max_hojas: "Requerido",
      });
    }

    if (isEmpty(precio)) {
      setErrors({
        ...errors,
        precio: "Requerido",
      });
    }

    if (min_hojas && max_hojas && precio) {
      onConfirm({
        ...item,
        min_hojas,
        max_hojas,
        sheet: selectedSheet.value,
        precio,
      });
    }
  };

  return (
    <div>
      <Input
        disabled={loading}
        onChange={onChangeSheetCountMin}
        value={min_hojas}
        title="Cant. Papel Min"
        error={errors.min_hojas}
        mask={Number}
      />

      <Input
        disabled={loading}
        onChange={onChangeSheetCountMax}
        value={max_hojas}
        title="Cant. Papel Max"
        error={errors.max_hojas}
        mask={Number}
      />

      <Dropdown
        title="Hoja"
        className="margin-top"
        options={hojasOptions}
        value={selectedSheet.value}
        onChange={onChangeSheet}
      />

      <Input
        disabled={loading}
        onChange={onChangePrice}
        value={precio}
        title="Precio"
        error={errors.precio}
        mask={Number}
      />

      <div className="actions">
        <Button disabled={loading} outlined onClick={onCancel}>
          Cancelar
        </Button>
        <Button loading={loading} onClick={onClickConfirm}>
          Confirmar
        </Button>
      </div>
    </div>
  );
};
